import { useState } from 'react';

const Testimonials = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Mitchell',
      role: 'Parent of Student',
      category: 'parent',
      quote: 'Northwest Ballet Theater has been transformative for our daughter Emma. The professional quality of their productions is remarkable, and the faculty truly cares about each student\'s individual growth. Emma has gained so much confidence and technical skill.',
      image: '/api/placeholder/100/100',
      studentName: 'Emma Mitchell',
      yearsWithNBT: '3 years'
    },
    {
      id: 2,
      name: 'David Chen',
      role: 'Former Student, Professional Dancer',
      category: 'alumni',
      quote: 'The training I received at Northwest Ballet Theater prepared me for my professional career in ways I never expected. The discipline, artistry, and technical foundation I gained here have been invaluable throughout my dance journey.',
      image: '/api/placeholder/100/100',
      currentPosition: 'Corps de Ballet, Pacific Northwest Ballet',
      yearsWithNBT: '8 years (2010-2018)'
    },
    {
      id: 3,
      name: 'Maria Rodriguez',
      role: 'Community Member',
      category: 'community',
      quote: 'NBT brings world-class ballet to our community. Their performances are always breathtaking and inspiring. I look forward to every production.',
      image: '/api/placeholder/100/100',
      attendance: 'Patron since 2015'
    },
    {
      id: 4,
      name: 'Jennifer Walsh',
      role: 'Parent of Student',
      category: 'parent',
      quote: 'The scholarship program made it possible for my son to pursue his passion for ballet. The support from the entire NBT community has been overwhelming. We are so grateful for this opportunity.',
      image: '/api/placeholder/100/100',
      studentName: 'Michael Walsh',
      yearsWithNBT: '2 years'
    },
    {
      id: 5,
      name: 'Alexandra Thompson',
      role: 'Former Student, Dance Teacher',
      category: 'alumni',
      quote: 'My time at NBT shaped not only my technique but also my understanding of ballet as an art form. The mentorship I received from the faculty continues to influence how I teach my own students today.',
      image: '/api/placeholder/100/100',
      currentPosition: 'Ballet Instructor, Seattle Dance Academy',
      yearsWithNBT: '6 years (2012-2018)'
    },
    {
      id: 6,
      name: 'Robert Kim',
      role: 'Local Business Owner',
      category: 'community',
      quote: 'Supporting Northwest Ballet Theater through our corporate sponsorship has been one of our best community investments. The cultural enrichment they provide to our region is immeasurable.',
      image: '/api/placeholder/100/100',
      business: 'Kim & Associates Architecture'
    },
    {
      id: 7,
      name: 'Lisa Anderson',
      role: 'Adult Student',
      category: 'student',
      quote: 'I started taking adult ballet classes at NBT three years ago with no prior experience. The welcoming environment and patient instruction have made this journey incredibly rewarding.',
      image: '/api/placeholder/100/100',
      program: 'Adult Ballet Program',
      yearsWithNBT: '3 years'
    },
    {
      id: 8,
      name: 'Dr. Patricia Williams',
      role: 'Board Member',
      category: 'community',
      quote: 'Serving on the NBT board has shown me firsthand the dedication and professionalism of this organization. Their commitment to excellence in both education and performance is truly inspiring.',
      image: '/api/placeholder/100/100',
      position: 'Board of Directors since 2019'
    }
  ];

  const categories = [
    { id: 'all', label: 'All Testimonials' },
    { id: 'parent', label: 'Parents' },
    { id: 'student', label: 'Students' },
    { id: 'alumni', label: 'Alumni' },
    { id: 'community', label: 'Community' }
  ];

  const filteredTestimonials = selectedCategory === 'all' 
    ? testimonials 
    : testimonials.filter(testimonial => testimonial.category === selectedCategory);

  return (
    <main className="min-h-screen bg-ballet-light">
      {/* Hero Section */}
      <div className="bg-elegant-gradient text-white py-20">
        <div className="container-custom text-center">
          <h1 className="text-5xl lg:text-6xl font-elegant font-bold mb-6">
            Testimonials
          </h1>
          <p className="text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto">
            Hear from our community about their experiences with Northwest Ballet Theater
          </p>
        </div>
      </div>

      <div className="container-custom section-padding">
        {/* Category Filter */}
        <div className="flex flex-wrap justify-center mb-12 bg-white rounded-2xl p-2 shadow-elegant">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
                selectedCategory === category.id
                  ? 'bg-ballet-burgundy text-white shadow-lg'
                  : 'text-ballet-burgundy hover:bg-ballet-light'
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {filteredTestimonials.map((testimonial) => (
            <div key={testimonial.id} className="card-elevated">
              <div className="p-8">
                <div className="flex items-start mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full mr-6 object-cover"
                  />
                  <div className="flex-1">
                    <h3 className="text-xl font-elegant font-bold text-ballet-burgundy mb-1">
                      {testimonial.name}
                    </h3>
                    <p className="text-gray-600 mb-2">{testimonial.role}</p>
                    
                    {/* Additional Info Based on Category */}
                    {testimonial.studentName && (
                      <p className="text-sm text-gray-500">Parent of {testimonial.studentName}</p>
                    )}
                    {testimonial.currentPosition && (
                      <p className="text-sm text-gray-500">{testimonial.currentPosition}</p>
                    )}
                    {testimonial.business && (
                      <p className="text-sm text-gray-500">{testimonial.business}</p>
                    )}
                    {testimonial.program && (
                      <p className="text-sm text-gray-500">{testimonial.program}</p>
                    )}
                    {testimonial.position && (
                      <p className="text-sm text-gray-500">{testimonial.position}</p>
                    )}
                    {testimonial.attendance && (
                      <p className="text-sm text-gray-500">{testimonial.attendance}</p>
                    )}
                  </div>
                </div>
                
                <blockquote className="text-gray-700 italic text-lg leading-relaxed mb-4">
                  "{testimonial.quote}"
                </blockquote>
                
                {testimonial.yearsWithNBT && (
                  <div className="flex items-center text-sm text-ballet-burgundy">
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {testimonial.yearsWithNBT}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="card-elevated">
          <div className="p-8 lg:p-12 text-center">
            <h2 className="text-3xl font-elegant font-bold gradient-text mb-6">
              Share Your Experience
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-8">
              We'd love to hear about your experience with Northwest Ballet Theater. 
              Your story could inspire others to join our ballet community.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="btn-primary">
                Submit Your Testimonial
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Testimonials;
